import {detailedReportService} from '../_services'
import {authHeader} from '../_helpers'
const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }

export const detailedReports = {
  namespaced: true,
  state: {
    places: [],
    genders: [],
    from: '',
    to: '',
    reports: [],
  },
  mutations: {
    setReports (state, reports) {
      state.reports = reports
    },
    setPlaces (state, places) {
      state.places = places
    },
    setGenders (state, genders) {
      state.genders = genders
    },
    setFrom (state, from) {
      state.from = from
    },
    setTo (state, to) {
      state.to = to
    },
  },
  actions: {
    async loadReports (state) {
      //console.log('no way')
      const reports = await detailedReportService.getReports(requestOptions)
      state.commit('setReports', reports)
    },
    // loadReports (context) {
    //   return detailedReportService.getReports()
    //     .then((response) => {
    //       //console.log(response)
    //       context.commit('setReports', {reports: response.data})
    //     })
    // },

  }
}
//
// export function fetchRepPerP () {
//   const requestOptions = {
//     method: 'GET',
//     headers: authHeader()
//   }
//
//   return axios.get(`${API_URL}/api/reports`, requestOptions).catch(handleResponse)
// }
//



// WEBPACK FOOTER //
// ./src/store/detailed-report.module.js